import { createFileRoute } from '@tanstack/react-router';
import ShiftManagementPage from '../../../../modules/shift-management';

export const Route = createFileRoute('/portal/managers/hr/shifts')({
  component: ShiftManagementPage,
});
